import { render, staticRenderFns } from "./Fatal.vue?vue&type=template&id=4fd066ee&"
import script from "./Fatal.vue?vue&type=script&lang=ts&"
export * from "./Fatal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports